<div class="header">
  <div class="title">{{ dynamicDialogTitle }}</div>
  <ts-button
    class="close-button"
    type="icon"
    htmlButtonType="button"
    icon="ts_close"
    (buttonClick)="discard()"
    [tabIndex]="-1"
  ></ts-button>
</div>

<ng-container *ngIf="dialogData.creatingView">
  <form [formGroup]="addViewForm">
    <mat-form-field class="subject">
      <mat-label>View Name</mat-label>
      <input matInput [formControlName]="'name'" autocomplete="off" data-cy="view-name" />
      <mat-error *ngIf="addViewForm.get('name').hasError('duplicateName')">
        This name already exists. Please choose a different name.
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex-auto">
      <mat-label>View Type</mat-label>
      <mat-select [formControlName]="'pipeline_type'">
        <mat-option [value]="'static'"> Static </mat-option>
        <mat-option [value]="'dynamic'"> Dynamic </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex-auto">
      <mat-label>Copy layout from existing view?</mat-label>
      <mat-select [formControlName]="'copy_from_pipeline_id'">
        <mat-option value=""> -- Do not copy -- </mat-option>
        <mat-option *ngFor="let pipeline of pipelines" [value]="pipeline.id">
          {{ pipeline.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    @if (activeUsers$ | async; as users) {
      <mat-form-field class="flex-auto">
        <mat-label>Record Owner</mat-label>
        <mat-select formControlName="record_owner_id">
          <mat-option *ngFor="let user of users" [value]="user.id">
            {{ user.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    } @else {
      <ts-skeleton height="48" class="mb-2"></ts-skeleton>
    }

    @if (teams$ | async; as teams) {
      <mat-form-field class="flex-auto">
        <mat-label>Team</mat-label>
        <mat-select formControlName="team_id">
          <mat-option *ngFor="let team of teams" [value]="team.id">
            {{ team.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    } @else {
      <ts-skeleton height="48" class="mb-2"></ts-skeleton>
    }
  </form>
</ng-container>

<ng-container *ngIf="dialogData.editingView">
  <form [formGroup]="editViewForm">
    <mat-form-field class="subject">
      <mat-label>View Name</mat-label>
      <input matInput [formControlName]="'name'" autocomplete="off" data-cy="view-name" />
      <mat-error *ngIf="editViewForm.get('name').hasError('duplicateName')">
        This name already exists. Please choose a different name.
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex-auto">
      <mat-label>Select a group below to move selected view into:</mat-label>
      <mat-select [formControlName]="'group'">
        <ng-container *ngIf="viewGroups">
          <mat-option *ngFor="let group of viewGroupOptions" [value]="group.id">
            {{ group.label }}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>

    @if (activeUsers$ | async; as users) {
      <mat-form-field class="flex-auto">
        <mat-label>Record Owner</mat-label>
        <mat-select formControlName="record_owner_id">
          <mat-option *ngFor="let user of users" [value]="user.id">
            {{ user.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    } @else {
      <ts-skeleton height="48" class="mb-2"></ts-skeleton>
    }

    @if (teams$ | async; as teams) {
      <mat-form-field class="flex-auto">
        <mat-label>Team</mat-label>
        <mat-select formControlName="team_id">
          <mat-option *ngFor="let team of teams" [value]="team.id">
            {{ team.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    } @else {
      <ts-skeleton height="48"></ts-skeleton>
    }
  </form>
</ng-container>

<ng-container *ngIf="dialogData.creatingGroup || dialogData.editingGroup">
  <form [formGroup]="addOrEditGroupForm">
    <mat-form-field class="subject">
      <mat-label>Group Name:</mat-label>
      <input matInput [formControlName]="'name'" autocomplete="off" data-cy="view-group-name" />
    </mat-form-field>
    <ng-container *ngIf="addOrEditGroupForm.get('name').errors?.duplicatedName">
      <mat-error>Group name is already taken.</mat-error>
    </ng-container>

    @if (activeUsers$ | async; as users) {
      <mat-form-field class="flex-auto">
        <mat-label>Record Owner</mat-label>
        <mat-select formControlName="record_owner_id">
          <mat-option *ngFor="let user of users" [value]="user.id">
            {{ user.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    } @else {
      <ts-skeleton height="48" class="mb-2"></ts-skeleton>
    }

    @if (teams$ | async; as teams) {
      <mat-form-field class="flex-auto">
        <mat-label>Team</mat-label>
        <mat-select formControlName="team_id">
          <mat-option *ngFor="let team of teams" [value]="team.id">
            {{ team.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    } @else {
      <ts-skeleton height="36"></ts-skeleton>
    }
  </form>
</ng-container>

<ng-container *ngIf="dialogData.reorderingGroups">
  <div class="reorder-groups">
    <div
      class="reorder-groups__list"
      cdkDropList
      [cdkDropListData]="viewGroupReorderOptions"
      (cdkDropListDropped)="dropped($event)"
    >
      <div class="reorder-groups__list__item" *ngFor="let group of viewGroupReorderOptions; let i = index" cdkDrag>
        <div class="drag-handle" cdkDragHandle>
          <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
        </div>
        <div class="reorder-groups__list__item__title">{{ group.label | uppercase }}</div>
      </div>
    </div>
  </div>
</ng-container>

<div class="actions justify-end">
  <div class="buttons">
    <ts-button variant="secondary" class="discard-button" (buttonClick)="discard()">
      <span>Cancel</span>
    </ts-button>
    <ts-button
      variant="primary"
      [debounceTime]="300"
      class="send-button ml-2"
      [disabled]="isSaveBtnDisabled"
      data-cy="save-view"
      (buttonClick)="save()"
    >
      <span *ngIf="!isLoading">Save</span>
      <mat-progress-spinner *ngIf="isLoading" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
    </ts-button>
  </div>
</div>
